import React, { useMemo } from 'react';
import { TextField } from '@material-ui/core';
import { RootStateOrAny, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import styles from '../styles';

type NameFieldProps = {
  disabled?: boolean;
  onChange: (e: any) => void;
  register: (name: string, options?: any) => void;
  error?: { message?: string };
  trigger: any;
  value?: string;
};

const NameField = ({
  disabled,
  onChange,
  register,
  error,
  trigger,
  value,
}: NameFieldProps) => {
  const errorMessage = error?.message;

  const classes = styles();
  const { t } = useTranslation();

  const attributes = useSelector(
    (state: RootStateOrAny) => state.AttributesReducer.attributeList,
  );
  const attributeNames = useMemo(
    () => new Set((attributes?.data || []).map(a => a.name)),
    [attributes],
  );

  const handleBlur = () => trigger('name');

  const mustBeUnique = v =>
    !attributeNames.has(v) || 'Attribute name is already in use';
  const handleInputRef = (...args) =>
    register('name', disabled ? undefined : { validate: { mustBeUnique } });

  return (
    <TextField
      value={value || ''}
      variant="outlined"
      label="Attribute Name"
      required
      inputRef={handleInputRef}
      name="name"
      inputProps={{ 'data-testid': 'name-textField' }}
      disabled={disabled}
      autoComplete="off"
      onChange={onChange}
      onBlur={handleBlur}
      className={classes.attributeField}
      helperText={errorMessage || t('attributes.name.helper')}
      FormHelperTextProps={{ className: classes.helperProps }}
      error={!!errorMessage}
    />
  );
};

export default NameField;
